import { Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ExtensibleControlValueAccessor } from 'src/app/shared/widgets/value-accessors/extensible-control-value.accessor';
import { AffCode } from '../shared/affcode.model';
import { AffCodeService } from '../shared/affcode.service';

/**
 * value - an array of AffCode strings
 */
@Component({
  selector: 'wl-affcode-chip-selector',
  templateUrl: './affcode-chip-selector.component.html',
  styleUrls: ['./affcode-chip-selector.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AffCodeChipSelectorComponent),
      multi: true,
    },
  ],
  standalone: false
})
export class AffCodeChipSelectorComponent extends ExtensibleControlValueAccessor implements OnInit {
  allAffCodes: AffCode[] = [];
  affCodeSearchResults: AffCode[] = [];
  selectedAffCodes: AffCode[] = [];
  constructor(private _affCodeService: AffCodeService) {
    super();
    this.value = [];
  }

  ngOnInit() {
    this._affCodeService.getAllAffCodes().then((codes) => {
      this.allAffCodes = codes;
      this.syncSelectedAffCodes();
    });
  }

  writeValue(value: string[]) {
    this.value = value ?? [];
    this.syncSelectedAffCodes();
  }

  selectedAffCodesChanged(value: AffCode[]) {
    if (value) {
      this.selectedAffCodes = value;
      this.value = value.map<string>((x) => x.AffCode);
      this.onChange(this.value);
    }
  }

  searchAffCodes(searchEvent: any) {
    const query = searchEvent.query?.toLowerCase() ?? '';
    const selectedCodes = this.selectedAffCodes.map((x) => x.AffCode);
    this.affCodeSearchResults =
      this.allAffCodes
        ?.filter((ac) => ac.AffCode.toLowerCase().includes(query))
        ?.filter((x) => !selectedCodes.includes(x.AffCode))
        ?.filter((x) => x.AffCode !== 'All' && x.AffCode !== 'Member') ?? [];
  }

  private syncSelectedAffCodes() {
    if (this.allAffCodes.length && this.value?.length) {
      this.selectedAffCodes = this.allAffCodes.filter((x) => this.value.includes(x.AffCode));
    }
  }
}
